<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
      viewBox="0 0 24 24"
    >
      <path
        d="M10.9999 5C10.9999 4.44772 11.4476 4 11.9999 4C12.5522 4 12.9999 4.44772 12.9999 5V16.5859L17.2929 12.293C17.6834 11.9024 18.3164 11.9024 18.707 12.293C19.0975 12.6835 19.0975 13.3165 18.707 13.707L12.707 19.707C12.3164 20.0976 11.6834 20.0976 11.2929 19.707L5.29289 13.707C4.90237 13.3165 4.90237 12.6835 5.29289 12.293C5.65901 11.9269 6.23801 11.9043 6.63078 12.2246L6.70696 12.293L10.9999 16.5859V5Z"
      />
    </svg>
  </template>
  
  <script>
  export default {
    name: 'IconApecScrollDown',
  };
  </script>
  
  <style scoped>
  .icon {
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    fill: inherit;
    flex-shrink: 0;
  }
  </style>
  